var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"title title-plantshop container"},[_c('div',{staticClass:"title-box-plantshop"},[_c('div',{staticClass:"title-style text-center"},[_c('h1',[_vm._v("Welcome to our Plant-Shop")])])])])
}]

export { render, staticRenderFns }